module.exports = __webpack_public_path__ + "static/img/zh-CN.887bd253.svg";